import React from 'react';
import Header from '../Header/Headerforprofile.jsx'
import Footer from '../Footer/Footer.jsx'
import Profilebox from './Profilebox.jsx';



function Profile(){

    

    

    




    // return (<div> {get_apps}</div>)

    return (
        <div>
        <Header></Header>
        <Profilebox></Profilebox>
        <Footer></Footer>
        </div>
    )
}

export default Profile;